import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickListNew: {
    id: 'UcaVpd',
    description: 'Name for print Pick List button with using custom document template',
    defaultMessage: 'Pick List - <b>NEW</b>',
  },
});
